<template>
  <v-card>
    <v-list dense>
      <v-subheader v-if="trendingActive">
        {{ $translate('TRENDING_EVENTS') }}
      </v-subheader>
      <v-subheader v-else>
        {{ results.length }} {{ $translate('ACTIVITIES_HOMEPAGE') }}
      </v-subheader>

      <template v-for="(event, index) in results">
        <v-divider v-if="index > 0" :key="index" inset />

        <v-list-item :key="event.EventId" @click="onEventClick(event)">
          <v-list-item-avatar>
            <v-img :src="event.PictureUrl" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-html="event.Name" />
            <v-list-item-action-text v-text="event.Type" style="opacity: 0.7" />
            <v-list-item-subtitle v-html="event.Subtitle" />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import uiHelpers from '@/shared/ui_helpers';
import { addLog } from '@/api/dssRequest';

export default {
  name: 'SearchResultsEventList',
  mixins: [uiHelpers],
  props: ['trendingActive', 'results'],
  methods: {
    onEventClick(event) {
      // Add user interaction to log
      addLog(
        this.$store.getters['auth/userName'],
        event.EventId,
        'Event',
        'Search',
        -1
      );
      // Go to event details screen
      this.goToPage('EventDetails', { event_id: event.EventId });
      // hide the search bar after locating to event
      this.$emit('hideSearchMenu');
    },
  },
};
</script>
